module.exports = __webpack_public_path__ + "static/media/carlos.2ba616d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/carlos.gif
// module id = 213
// module chunks = 0